import { Box, Paragraph30 } from '@squareup/dex-ui-shared-base';
import React from 'react';

import { HttpMethods, HttpMethodString } from '../HttpMethodString';

import styles from './http-method-name.module.css';

const HttpMethodName = ({
  httpMethod,
  name,
}: {
  httpMethod?: HttpMethods | undefined;
  name: string;
}) => {
  return (
    <Box margin={{ bottom: '4x', top: '1x' }} className={styles['subtitle']}>
      <Paragraph30 as={'span'} weight="medium">
        {httpMethod && (
          <HttpMethodString httpMethod={httpMethod}></HttpMethodString>
        )}
      </Paragraph30>
      <Paragraph30>&nbsp;{name}</Paragraph30>
    </Box>
  );
};

export { HttpMethodName };
